import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Checkbox, FormControl, FormLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface FreeCheckboxSelectWithCountProps<T> {
    options: { value: T; label: string }[];
    values: { value: T; label: string }[]; 
    onValueSelected: (value: { value: T; label: string }[]) => void;
    placeholder?: string;
    label?: string;
}

const FreeCheckboxSelectWithCount = <T,>({
    options,
    values,
    onValueSelected,
    placeholder,
    label,
}: FreeCheckboxSelectWithCountProps<T>): React.ReactElement => {
    const { t } = useTranslation();

    // Display text logic
    const displayText =
        values.length === 1
            ? values[0]?.label || ''
            : values.length > 1
            ? `${values.length} ${t('item.priority_selection')}`
            : placeholder || '';

    return (
        <FormControl fullWidth>
            {label && <FormLabel>{label}</FormLabel>}
            <Autocomplete
                multiple
                disableCloseOnSelect
                options={options}
                value={values}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                renderOption={(props, option, { selected }) => (
                    <li
                        {...props}
                        style={{
                            margin: 0,
                            padding: 0,
                        }}
                    >
                        <Checkbox
                            style={{ marginRight: 8 }}
                            checked={selected} // Reflect selection state
                        />
                        {option.label}
                    </li>
                )}
                renderValue={() => null} // Prevent chips from rendering
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        placeholder={displayText}
                        slotProps={{
                            input: {
                                ...params.slotProps.input,
                                disableUnderline: true,
                                sx: {
                                    paddingLeft: '10px',
                                },
                            },
                            htmlInput: {
                                ...params.slotProps.htmlInput
                            }
                        }}
                    />
                )}
                onChange={(event, newValue) => {
                    onValueSelected(newValue);
                }}
            />
        </FormControl>
    );
};

export default FreeCheckboxSelectWithCount;
